module.exports = __webpack_public_path__ + "static/media/server-crash.25c59037.png";